/**
 * Детерминированная случайность.
 *
 * Ни один механизм не имеет права звать Math.random. Иначе «сид» — это
 * обещание, которое модуль не выполняет: форма перестаёт воспроизводиться,
 * и вместе с ней перестаёт работать кэш, потому что один ключ начинает
 * означать разные картинки.
 */

/** Поток чисел 0…1. */
export type Rng = () => number

/**
 * mulberry32 — короткий и достаточный.
 *
 * Криптостойкость здесь не нужна и вредна: нам нужна скорость, потому что
 * поле 120×220 запрашивает ГПСЧ десятки тысяч раз за одно запекание.
 */
export function rng(seed: number): Rng {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/**
 * Свёртка ключа в число.
 *
 * Сид показа выводится из корневого сида, имени механизма, соли и ступени
 * размера. Смешивать их сложением нельзя: seed+1 с механизмом A совпал бы
 * с seed с механизмом B, и два разных перехода получили бы одну форму.
 */
export function hashKey(seed: number, ...parts: (string | number)[]): number {
  let h = (seed ^ 0x9e3779b9) >>> 0

  for (const part of parts) {
    const s = typeof part === 'number' ? part.toString(36) : part
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i)
      h = Math.imul(h, 0x01000193) >>> 0
    }
    // Разделитель между частями: без него ('ab','c') и ('a','bc')
    // свернулись бы в одно и то же.
    h = (h ^ 0x5f356495) >>> 0
  }
  return h >>> 0
}

/** Случайный сид для новой сессии. Единственное место с Math.random. */
export const randomSeed = (): number => Math.floor(Math.random() * 0x7fffffff)
